import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose, bindActionCreators } from "redux";

import { NavigationHeader } from "./navHeader";
import { VideoListingComponent } from "./videosListing";
import { LoaderComponent } from "../../components/loader";
import { getParameterByName, IsEmpty } from "../../util/commonFunctions";

// actions
import {
  getSeeAllDataAction,
  getHomePageSectionSeeAll,
  setManualRailData
} from "../../actions";
import HelmetComponent from "../../components/shared/Helmet";

class SeeAll extends PureComponent {
  state = {
    activeTier: null,
    offset: 0,
    max: 24,
    seeAllPageTitle: null
  };

  setSeeAllData = async data => {
    this.setState({
      seeAllPageTitle: data.title
    });
    switch (true) {
      case data.railType && data.railType.toLowerCase() == "custom":
        this.props.setManualRailData(data.contentList);
        break;
      case data.railType && data.railType.toLowerCase() == "auto":
        this.getSeeAllData();
        this.lazyLoadContainer = React.createRef();
        window.addEventListener("scroll", this.onScroll, false); // bind scroll event
        break;
      default:
        break;
    }
  };

  componentDidMount = async () => {
    let sectionId = getParameterByName("sectionId");
    if (!IsEmpty(sectionId)) {
      const { getHomePageSectionSeeAll, currentLanguage } = this.props;
      await getHomePageSectionSeeAll({ sectionId, language: currentLanguage });
      this.setSeeAllData(this.props.seeAllReducer.homeSectionData);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  componentDidUpdate() {}

  getSeeAllData = async () => {
    const { max, offset } = this.state;
    const { getSeeAllDataAction, currentLanguage } = this.props;
    await getSeeAllDataAction({ offset, max, language: currentLanguage });
  };

  ///  lazy load on scroll
  onScroll = () => {
    const {
      match: {
        params: { rail }
      },
      seeAllReducer: { isSeeAllDataLoading, seeAllData }
    } = this.props;
    const {
      top: containerTop
    } = this.lazyLoadContainer.current.getBoundingClientRect();
    const listing =
      seeAllData && Object.values(seeAllData).map(values => values);
    const lastList =
      Array.isArray(listing) && listing.length && listing[listing.length - 1];
    if (
      !isSeeAllDataLoading &&
      containerTop < 100 &&
      lastList &&
      lastList.length
    ) {
      this.setState(
        prevState => ({
          offset: prevState.offset + prevState.max
        }),
        () => {
          this.getSeeAllData();
        }
      );
    }
  };

  render() {
    const { seeAllReducer } = this.props;
    const {
      seeAllData = {},
      isHomeSectionDataLoading,
      homeSectionData
    } = seeAllReducer;

    // extract items list
    const listing =
      seeAllData && Object.values(seeAllData).map(values => values);

    return (
      <React.Fragment>
        <HelmetComponent
          title={homeSectionData && homeSectionData.title + " | ausbiz"}
          noIndex="false"
        />
        <section className="tier-container see-all-container">
          <LoaderComponent isLoading={isHomeSectionDataLoading} />
          <section className="tier-navigation">
            {!IsEmpty(this.state.seeAllPageTitle) && (
              <NavigationHeader title={this.state.seeAllPageTitle} />
            )}
          </section>
          <div className="w-100"></div>
          <section
            className="container tier-listing"
            ref={this.lazyLoadContainer}
          >
            <div className="row">
              <VideoListingComponent listing={listing} />
            </div>
          </section>
        </section>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    seeAllReducer: state.seeAll,
    currentLanguage: state.language.currentLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSeeAllDataAction,
      getHomePageSectionSeeAll,
      setManualRailData
    },
    dispatch
  );
}

function loadData(store) {
  const currentLanguage = store.getState().language.currentLanguage;
  return store.dispatch(getSeeAllDataAction({language: currentLanguage}));
}

export default {
  component: compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
  )(SeeAll)
};
